import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';



class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 50000;
    }

    // Login Page
    signUp = (request) =>{
       return  axios.post( 'sign-up', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

       return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getSlides = (params = null) => {
        return axios.get( `slideshows`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateStatus = (request) =>{
        return  axios.patch( 'update-order-status', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    warranty = (request) =>{
        return  axios.post( 'products/use-warranty', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getReasons = (params = null ) => {
        return axios.get( `/products/reject-reasons`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    searchProduct = (code) =>{
        return  axios.get( `products/search/${code}`,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }




    getDashboard = (params = null , id) => {
        return axios.get( `reports/manager-dashboard`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getSalesChart = (params = null , id) => {
        return axios.get( `reports/sales`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getVendorsReport = (params = null , id) => {
        return axios.get( `reports/vendors`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getRegionReport = (params = null , id) => {
        return axios.get( `reports/provinces`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getBrandReport = (params = null , id) => {
        return axios.get( `reports/brands`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Vendor Page
    getVendors = (params = null) => {
        return axios.get( `products/vendors`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getBasics = (params = null) => {

        return axios.get( `products/get-basics`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;